'use client';
import get from 'lodash/get';
import { checkType } from '@/common/ultils';
import React from 'react';
import Image from 'next/image';

const EventBanner = ({ bannerMiddles, index = 1, deviceType }) => {
  const dataBanner = get(bannerMiddles, `results[${index}]`);

  if (!dataBanner) {
    return null;
  }

  const fileUrl = checkType(deviceType, dataBanner, 0, 'fileUrl', 'sharpMedias');
  return (
    <a href={`${dataBanner.linkTo}`} target="_blank" rel="noopener noreferrer" className="bg-gray-300 flex items-center justify-center text-gray-600">
      <Image src={fileUrl} alt={dataBanner.name} className="w-full h-auto object-cover position-initial" fill loading="lazy" />
      {/* <img src={fileUrl} alt={dataBanner.name} className="w-full h-auto object-cover" loading="lazy" /> */}
    </a>
  );
};

export default EventBanner;

